import React from 'react';
import support from '../assets/images/img/support-team.png';
import { FaHandPointRight } from "react-icons/fa";
import { Link } from 'react-router-dom';


export default function SupportTeam() {
  return (

<>

<div className='container'>
<div className='support_our_team'>
<div className='wrapper'>
<div className='row'>
    <div className='col-lg-8'>

    <h2>Consult with the Experts</h2>
    
    <div className='d-flex'>
    <div> <span className='pointer'><FaHandPointRight/></span> </div>
    <p>You are just starting your journey or looking to optimize your existing environment, our team of certified server experts is here to guide you every step of the way.</p>


    </div>

    <Link className='btn btn-primary btn-lg' to='/contact'>Contact Us</Link>

    </div>

    <div className='col-lg-4 text-end'>

        <img className='support_icon' src={support} alt='' />

    </div>
</div>
</div>
</div>
</div>

</>



  )
}
